import { grupoEtapasService } from "../../../_services/grupoEtapas.service";
import { tipoEtapasService } from "../../../_services/tipoEtapas.service";
import { dashboardConstants } from "../constants";

export const getTipoEtapas = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await tipoEtapasService.getTipoEtapas(data);

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_TIPO_ETAPAS, payload: data };
  }
};

export const getGrupoEtapas = () => async (dispatch) => {
  dispatch(request());
  try {
    const response = await grupoEtapasService.getGrupoEtapas();

    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_GRUPO_ETAPAS, payload: data };
  }
};

